module.exports = __webpack_public_path__ + "img/icon-user-usa.2f1f6258.svg";